import { FilterType } from '@/types/analytics/analytics.types';

/**
 * Updates filter types that are promotedMetadata to historicalMetadata
 *
 * Source version: 1 or 2
 * Destination version: 3
 */
export default (report) => {
    const { definition } = report;

    if (definition.version > 2) {
        return report;
    }
    definition.version = 3;

    const filters = definition?.globals?.filters;
    filters?.map((filter) => {
        filter.filterType =
            filter.filterType === 'promotedMetadata' ? FilterType.HistoricalMetadata : filter.filterType;

        return filter;
    });

    return report;
};
